var GraphicShapeView = require('../graphic/graphic'),
    _ = require('underscore'),
    GraphicStampShape = require('../graphicStamp/shapeView');


/**
 *
 * Likely want an SVG shape rather than extending from graphic shape.
 * intertwined with color change, other aspects of it
 */


var TextStampView = GraphicShapeView.extend({

    dontCreateButtonSet: true, // we don't want the delete button
    DONT_CREATE_SELECT_HANDLES: true, // test no resize ... only want font-size, text change, font having this resizable ( not both )

    initialize: function( options ) {

        GraphicShapeView.prototype.initialize.apply( this, arguments );

        this.shapeTransformModel = this.shapeModel.getTransformModel();

        var uiModel = this.pgNoteModel.uiModel;

        this.shapeTransformModel.initializePageValues( this.shapeModel.pageModel, this.options.scale );
        this.shapeTransformModel.setRotation( uiModel.get( 'rotationAtZeroPageRotation') );

        this.listenTo( uiModel, 'change:selectedStamp', this.stampChange );

        /* Don't allow any changes that would alter the existing path now -- it is a path that can only be moved and resized, like a graphic */
        this.listenTo( uiModel, 'change:generatedText', this.update );
        this.listenTo( uiModel, 'change:fontSize',      this.update );
        this.listenTo( uiModel, 'change:font',          this.update );

        this.listenTo( uiModel, 'change:textColor',     this.textColorChange ); // could put an option parent in the event ...
        this.listenTo( uiModel, 'change:textOpacity',   this.textColorChange ); // note: change change opacity and color at the same time, so no dupe

    },

    render: function() {

        GraphicShapeView.prototype.render.apply( this, arguments );
        this._setTransformValuesOnRender( this.transform.bind(this) );

    },

    _renderFromModel: function( shapeModel, scale ) {

        var el = this.paper.text()
            .attr( shapeModel.getNonPathInactiveSVGAttrs( this.channel ) );

        this.setElement( el );
        this._setTransformValuesOnRender( this.transform.bind(this) );

        return el;

    },

    _setTransformValuesOnRender: function( cb ) {

        var shapeTransformModel = this.shapeTransformModel;
        shapeTransformModel.setOBox(  this.el.getBBox(1) );
        shapeTransformModel.setOx( this.el.attr('x') );
        shapeTransformModel.setOy( this.el.attr('y') );
        shapeTransformModel.getPageModel().updateTransform();
        cb && cb();

    },

    // TODO: a better way to update 'mediated' with probably an option to indicate size change ( and need to update bbox ) or note
    update: function( noteUiModel ) {

        this._updateAttributes( noteUiModel );

        this.shapeTransformModel.setOBox( this.el.getBBox(1) );  // Need to update since the bbox changes
        this.shapeTransformModel.getPageModel().updateTransform(); // needed these aren't changing
        this.transform();

        // This should be slow but appears to work ( comment written when did a resize, without it is good )
        // Performance is not great in IE
        this._destroySelectSet();
        this._createSelectSet();

    },

    /**
     *   TODO: shapeModel.setZoneColor
     *    - hack for now: -- would call this.onChangeColor but attributes updated
     *    - just set color on the shape model -- if leave like this should also do on the hover model
     *    - real answer is linking the noteUiModel to the shape model ...
     */
    textColorChange: function( noteUiModel ) {

        this._updateAttributes( noteUiModel );
        this.shapeModel.setZoneColor( noteUiModel.get('textColor') );

    },

    _updateAttributes: function(noteUiModel) {

        this.el.attr({
            text: noteUiModel.getGeneratedText(),
            'font-size': noteUiModel.getFontSize(),
            'font-family': noteUiModel.getFont(),
            fill: noteUiModel.getColorToApply(),
            opacity: noteUiModel.getTextOpacity()
        });

    },

    // -- may want a handleset that share the same transform ...
    _scaleShapeEl: function( scale ) {

        var shapePageTransformModel = this.shapeTransformModel.getPageModel();
        shapePageTransformModel.setScale( scale );
        shapePageTransformModel.updateTransform();
        this.transform();
    },

    // Depends if new or not ... now the inputs could be invalid ... what to do ? -- logic may need to go into re-render canvas
    stampChange: function( noteUiModel ) {

        if ( !noteUiModel.getInputsValid() ) {

            noteUiModel.setStampPlaced( false ); // TODO: this should be higher up when changing the stamp
            this.channel.command( 'replaceExistingTextStampShapeWithHoverStamp' );
        }
        else
        {
            this.update( noteUiModel );

        }

    },

    /* Could put into a getTransform string on the model -- and have others inherit from it -- do if need to use for other shapes */
    /* Eg have a getTransform function on the model -- it is created from those values now -- diff modules would override */
    transform: function( t ) {

        var shapeTransModel = this.shapeTransformModel;

        var trans = '';
        var non_view_transform = '';

        if ( t ) {
            trans += t; // I think this is typically the view transform
        }

        trans += shapeTransModel.getPageModel().getTransform(); // was passing in via cb param ( which here was t )

        // trans += 's' + stamp.sx + ',' + stamp.sy;  // good for move but breaks resize moves ... ( RESIZE NOT DONE )
        // Rotation -- From Original -- resize move becomes off

        var r = shapeTransModel.getRotation();

        if ( r !== 0 ) {

            var rotateTrans = 'r' + r  + ',' + shapeTransModel.getOx() + ',' +  shapeTransModel.getOy();
            non_view_transform += rotateTrans;
            shapeTransModel.setNonViewRotateTransform( rotateTrans );
        }

        // Y-Char Offset
        var textOffsetTransform = 't0,' + shapeTransModel.getOBox().height / 2;
        shapeTransModel.setTextYOffsetTransform( textOffsetTransform );

        non_view_transform += textOffsetTransform ;
        shapeTransModel.setNonViewTransform( non_view_transform );

        trans += non_view_transform;
        this.el.transform( trans );

    },

    // It's only one shape, select it automatically
    // Maybe this is a single shape mixin -- but we already need to refactor toggle active
    toggleActive: GraphicStampShape.prototype.toggleActive

});


module.exports = TextStampView;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/textStamp/shapeView.js
 ** module id = 322
 ** module chunks = 0
 **/